module.exports = __webpack_public_path__ + "static/media/splash-secondary-banner.33ae3a52.png";